<template>
  <div>
    <!-- 根据加载状态显示加载界面或战斗界面 -->
    <BattleLoading 
      v-if="isLoading" 
      :progress="loadingProgress" 
    />
    <BattleMain 
      v-else 
      :context="context" 
      :isOperating="isOperating" 
      :actionState="actionState" 
    />
  </div>
</template>

<script>
import BattleLoading from "@/views/pve/BattleLoading.vue"; // 加载界面
import BattleMain from "@/views/pve/BattleMain.vue"; // 战斗主界面
import { usePveStore } from "@/stores/pveStore"; // 引入 Pinia Store

export default {
  components: {
    BattleLoading,
    BattleMain,
  },
  data() {
    return {
      isLoading: true, // 当前是否处于加载状态
      loadingProgress: 0, // 加载进度
      context: null, // 战斗上下文
      isOperating: false, // 是否可以操作
      actionState: {
        playerAction: "none",
        opponentAction: "none",
        firstMove: "player",
      },
      minimumLoadingTime: 3000, // 最小加载时间（毫秒）
      loadingStartTime: null, // 记录加载开始的时间戳
    };
  },
  watch: {
    // 监听加载进度，进度条满后切换到战斗界面
    loadingProgress(newProgress) {
      if (newProgress >= 100) {
        const elapsedTime = Date.now() - this.loadingStartTime;

        if (elapsedTime >= this.minimumLoadingTime) {
          this.isLoading = false;
        } else {
          const remainingTime = this.minimumLoadingTime - elapsedTime;
          setTimeout(() => {
            this.isLoading = false;
          }, remainingTime);
        }
      }
    },
  },
  async mounted() {
    this.initializeSocketConnections();
  },
  methods: {
    // 初始化 Socket 连接并发送 pveInitLoad
    initializeSocketConnections() {
      const pveStore = usePveStore(); // 使用 Pinia Store
      const pveSocket = this.$pveSocket; // 全局注入的 PVE Socket
      const userId = this.$getUserId(); // 当前用户 ID
      const opponentConfig = pveStore.opponentConfig; // 从 Pinia 获取对手配置

      // 检查对手配置
      if (!opponentConfig) {
        console.error("对手配置不存在，无法初始化战斗！");
        return;
      }

      // 记录加载开始时间
      this.loadingStartTime = Date.now();

      // 发送初始化事件
      this.startLoadingProcess(userId, opponentConfig, pveSocket);
    },

    // 开始加载过程
    startLoadingProcess(userId, opponentConfig, pveSocket) {
      // 发送 pveInitLoad 事件到后端
      pveSocket.emit("pveInitLoad", { player1Id: userId, opponentConfig });

      // 模拟加载进度
      this.simulateLoadingProgress();

      // 监听加载完成事件
      pveSocket.on("pveInitLoaded", (response) => {
        if (response.success) {
          console.log("加载成功，收到上下文:", response.context);

          const pveStore = usePveStore();

          // 将上下文存储到 Pinia
          pveStore.setContext(response.context);

          // 设置双方玩家信息
          const selfInfo = {
            player_name: response.context.player1.name,
            avatar: response.context.player1.avatarUrl,
          };
          const opponentInfo = {
            player_name: response.context.player2.name,
            avatar: response.context.player2.avatarUrl,
          };
          pveStore.setPlayerInfo(selfInfo, opponentInfo);

          // 更新本地状态
          this.context = response.context;
        } else {
          console.error("加载失败:", response.message);
        }
      });
    },

    // 模拟加载进度
    simulateLoadingProgress() {
      const interval = setInterval(() => {
        if (this.loadingProgress < 100) {
          this.loadingProgress += 5;
        } else {
          clearInterval(interval);
        }
      }, 200); // 每 200ms 增加进度
    },
  },
};
</script>

<style scoped>
/* 样式保持不变 */
</style>
